export default __webpack_public_path__ + "img/12a8f1195e16b30c087447736f0de4a3.png";